<template>
  <div>
    <form
      method="post"
      @submit.prevent="filterObjects(searchQuery)"
    >
      <div class="row">
        <div class="col-md-8">
          <v-text-input
            id="item-search-input"
            v-model="searchQuery"
            placeholder="word.search"
          />
        </div>
        <div class="col-md-4">
          <v-button
            :text="`${$t('word.search')} (${totalObjects})`"
            id="item-search-button"
            :translate-text="false"
            icon="search"
            :block="true"
            style-type="primary"
            type="submit"
            :loader="{loading: loading}"
          />
        </div>
      </div>
    </form>
    <hr/>

    <transition name="fade-down">
      <div v-if="showItems">
        <div v-if="objectList.length > 0">
          <div>
            <v-item
              v-for="item in objectList"
              :key="item.uuid"
              :item="item"
              :organisation-name="organisation.name"
              :is-addable="true"
              @add-item="$emit('selected', item.id)"
            />
          </div>
          <div class="d-flex justify-content-center">
            <v-button
              text="phrase.load_more"
              id="item-search-load-more"
              v-if="nextPageUrl"
              @click="getObjects(nextPageUrl, true)"
              :loader="{loading: loading}"
            />
          </div>
        </div>
      </div>
    </transition>

    <div
      v-if="objectList.length === 0 && !loading"
      class="d-flex flex-column align-items-center"
    >
      <div class="text-center text-muted mb-2">
        {{ $t('phrase.no_questions_found') }}
      </div>
      <v-button
        v-if="user.su"
        id="item-search-add-new"
        text="phrase.add_new"
        icon="plus"
        style-type="secondary"
        size="sm"
        @click="$emit('add-new-item')"
      />
    </div>
  </div>
</template>

<script>
import TextInput from '@/common/components/inputs/TextInput.vue';
import Button from '@/common/components/Button.vue';
import { GenericListMixin } from '@/common/utils/mixins';
import Item from '@/organisation/components/research/Item.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ItemSearch',
  mixins: [
    GenericListMixin,
  ],
  components: {
    'v-button': Button,
    'v-item': Item,
    'v-text-input': TextInput,
  },
  computed: {
    ...mapGetters(['user']),
  },
  props: {
    researchTypeSlug: {
      type: String,
    },
    organisation: {
      type: Object,
    },
  },
  methods: {
    getParams() {
      if (this.user.su) {
        return {
          organisation_slug: this.organisation.slug,
          show_all: true,
        };
      }
      return {
        organisation_slug: this.organisation.slug,
        research_type_slug: this.researchTypeSlug,
      };
    },
    postProcess() {
      this.showItems = true;
    },
  },
  data() {
    return {
      search: '',
      apiPath: 'org/items/',
      items: null,
      showItems: false,
    };
  },
};
</script>
